const getOtherScope = (state) => state.other.shared.phones

export const getRelatedPeople = (state) => {
	return getOtherScope(state).exists
}
